import { InputField } from 'lib/iterable-hook-form';
import { INTEGRATION_FORM_CONTENT } from 'modules/mobileApps/constants';
import { IntegrationFormField } from 'modules/mobileApps/context/integrationForm';
import { FormField } from 'ui/formField';
import { INPUT_TEXT_TYPES } from 'ui/inputs';
import { APNS_INTEGRATION_FORM_ID } from '../ApnsIntegrationForm';
import { EnvironmentRadioList, FileDropzoneField } from '../components';

const { inputs } = INTEGRATION_FORM_CONTENT.authMethods.p12Certificate;

export const P12FormPart = () => {
  return (
    <>
      <FileDropzoneField
        data-test={`${APNS_INTEGRATION_FORM_ID}-upload-p12-file`}
        accept={{ 'application/x-pkcs12': ['.p12'] }}
        name={IntegrationFormField.p12file}
      />
      <FormField labelText={inputs.p12password.label}>
        <InputField
          data-test={`${APNS_INTEGRATION_FORM_ID}-p12-password-field`}
          name={IntegrationFormField.p12password}
          placeholder={inputs.p12password.placeholder}
          type={INPUT_TEXT_TYPES.PASSWORD}
        />
      </FormField>
      <EnvironmentRadioList />
    </>
  );
};
